<template>
  <div>
      <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " label="Name" />
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Profession</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Profession</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/inertia-vue3'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
      Link,
      Head,
  },
  layout: Layout,
  props: {
    title: String,
    profession: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          name: this.profession.name,
          color: this.profession.color,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('professions.update', this.profession.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this profession?')) {
        this.$inertia.delete(this.route('professions.destroy', this.profession.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this profession?')) {
        this.$inertia.put(this.route('professions.restore', this.profession.id))
      }
    },
  },
}
</script>
